import { render, staticRenderFns } from "./TextWrapper.vue?vue&type=template&id=03fea356&scoped=true&"
import script from "./TextWrapper.vue?vue&type=script&lang=ts&"
export * from "./TextWrapper.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03fea356",
  null
  
)

export default component.exports